import { TextInput, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PartSerialNumberField: FunctionComponent<Props> = ({
    className = '',
    onChange,
    partSerialNumber,
    testId = TEST_ID
}) => {
    const t = useTranslation();

    const handleChange = (value: string) => onChange({ partSerialNumber: value });

    return (
        <VerticalContainer
            className={`${styles.partSerialNumberField} ${className}`}
            testId={testId}>
            <Wrapper className={styles.label}>{t.LOG_SERVICE_PART_SERIAL_NUMBER}</Wrapper>

            <TextInput
                className={styles.serialInput}
                onChange={handleChange}
                placeholder={t.LOG_SERVICE_PART_SERIAL_NUMBER_PLACEHOLDER}
                testId={`${testId}-input`}
                value={partSerialNumber}
            />
        </VerticalContainer>
    );
};

export default PartSerialNumberField;
